import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert, Row, Col, CardTitle, CardHeader } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton/CustomButton";
import { getBusinessNatureList } from "../../redux/actions/getBusinessNatureListAction";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { AiOutlineSearch } from "react-icons/ai";
import { addorUpdateBusinessNature } from "../../redux/actions/addOrUpdateBusinessNatureAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { getBusinessNatureTableList } from "../../redux/actions/getBusinessNatureTableListAction";
import EditIcon from "@mui/icons-material/Edit";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import { Tooltip } from "antd";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import Util from "../../validation";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminBusinessNatureManagement = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [getBusinessNatureResArray, setgetBusinessNatureResArray] = useState(
		[]
	);
	const [getBusinessNatureListStatus, setGetBusinessNatureListStatus] =
		useState(false);

	const [
		getBusinessNatureListTableResArray,
		setGetBusinessNatureListTableResArray
	] = useState([]);

	const [
		getBusinessNatureTableListStatus,
		setGetBusinessNatureTableListStatus
	] = useState(false);
	// const [logoutvalue, setLogoutvalue] = useState(false);
	const [addEditBusinessNature, setAddEditBusinessNature] = useState("");
	const [mccRange, setMccRange] = useState("")
	const [viewOpen, setViewOpen] = useState(false);
	const [editOpen, setEditOpen] = useState(false);
	const [addOpen, setAddOpen] = useState(false);
	const [updateBusinessNature, setUpdateBusinessNature] = useState(false);
	const [operationId, setOperationId] = useState("");
	const [updateEntityTypeResArray, setUpdateEntityTypeResArray] = useState("");
	const [notificationOpen, setNotificationOpen] = useState(false);

	const getBusinessNatureListRes = useSelector(
		({ getBusinessNatureList }) => getBusinessNatureList
	);
	console.log(getBusinessNatureListRes, "getBusinessNatureListRes");

	const updateBusinessNatureRes = useSelector(
		({ addorUpdateBusinessNature }) => addorUpdateBusinessNature
	);

	const getBusinessNatureTableListRes = useSelector(
		({ getBusinessNatureTableList }) => getBusinessNatureTableList
	);

	console.log("getBusinessNatureTableListRes", getBusinessNatureTableListRes);

	console.log("getBusinessNatureTableListRes", getBusinessNatureTableListRes);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	// const [role, setRole] = useState("");
	const [businessNature, setBusinessNature] = useState("");

	const BusinessNatureManagementRequest = () => {
		setIsLoading(true);
		setGetBusinessNatureListStatus(true);
		const BusinessNatureManagementReq = {
			// adminId: 2,
			adminId: val.adminIDS,

			businessNature: businessNature
		};
		dispatch(getBusinessNatureList(BusinessNatureManagementReq, authToken));
	};

	const getBusinessNatureListStatusFunc = () => {
		if (getBusinessNatureListStatus) {
			if (getBusinessNatureListRes.data.status == "success") {
				setIsLoading(false);
				setgetBusinessNatureResArray(
					[].concat(getBusinessNatureListRes.data.roleList)
				);
			}
			if (getBusinessNatureListRes.data.status == "failed") {
				setIsLoading(false);
				setgetBusinessNatureResArray(getBusinessNatureListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getBusinessNatureListRes.data.description ||
					getBusinessNatureListRes.description
				);
				if (
					getBusinessNatureListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getBusinessNatureListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getBusinessNatureListRes.data.status == "INVALID REQUEST") {
				setIsLoading(false);
				setgetBusinessNatureResArray(getBusinessNatureListRes.data);
				NotificationPopups(
					"error",
					"INVALID REQUEST",
					getBusinessNatureListRes.data.description ||
					getBusinessNatureListRes.description
				);
			}
			if (getBusinessNatureListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetBusinessNatureResArray(getBusinessNatureListRes.data);
				NotificationPopups(
					"error",
					"NOT FOUND",
					getBusinessNatureListRes.data.description ||
					getBusinessNatureListRes.description
				);
			}
		}
	};

	useEffect(() => {
		getBusinessNatureListStatusFunc();
	}, [getBusinessNatureListRes.data.status]);

	const BusinessNatureManagementTableRequest = () => {
		const Req = {
			// adminId: 2,
			adminId: val.adminIDS,

			businessNature: businessNature
		};
		dispatch(
			getBusinessNatureTableList(Req, regenerateTokenRes.data.AuthToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			BusinessNatureManagementTableRequest();
			BusinessNatureManagementRequest();
		}
	}, [regenerateTokenRes.data.status]);

	// const BusinessNatureManagementTableFunc = () => {
	//   if (getBusinessNatureTableListRes.data.status == "success") {
	//     setGetBusinessNatureListTableResArray(
	//       [].concat(getBusinessNatureTableListRes.data.roleList)
	//     );
	//   };
	//   if (getBusinessNatureTableListRes.data.status == "failed") {
	//     setGetBusinessNatureListTableResArray(getBusinessNatureTableListRes.data);
	//   };

	// }

	// useEffect(() => {
	//   BusinessNatureManagementTableFunc();
	// }, [getBusinessNatureTableListRes.data.status]);

	// Update

	const AddUpdateBusinessNatureRequest = () => {
		setEditOpen(false);
		setAddOpen(false);
		setUpdateBusinessNature(true);
		const addBusinessNatureReq = {
			// adminId: 2,
			adminId: val.adminIDS,
			
			operationId: operationId,
			businessNature: addEditBusinessNature,
			mccRange: mccRange
		};
		dispatch(addorUpdateBusinessNature(addBusinessNatureReq, authToken));
	};

	const updateBusinessNatureStatus = () => {
		if (updateBusinessNature) {
			if (updateBusinessNatureRes.data.status == "success") {
				setUpdateEntityTypeResArray(updateBusinessNatureRes.data);
				setNotificationOpen(true);
				BusinessNatureManagementRequest();
				BusinessNatureManagementTableRequest();
			}
			if (updateBusinessNatureRes.data.status == "failed") {
				setUpdateEntityTypeResArray(updateBusinessNatureRes.data);
				setNotificationOpen(true);
				if (
					updateBusinessNatureRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateBusinessNatureRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateBusinessNatureRes.data.status == "INVALID REQUEST") {
				setUpdateEntityTypeResArray(updateBusinessNatureRes.data);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		updateBusinessNatureStatus();
	}, [updateBusinessNatureRes.data.status]);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "BusinessNature") {
			setBusinessNature(value == "Select Business Nature" ? "" : value);
		}

		if (name === "EditBusinessNature") {
			Util.alphaNumeric(value)
				? setAddEditBusinessNature(value)
				: setAddEditBusinessNature(addEditBusinessNature);
		}
		if (name == "mccnature") {
			setMccRange(value)

		}
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setViewOpen(false);
		setEditOpen(false);
		setAddOpen(false);
		setAddEditBusinessNature("");
		setMccRange("")
	};

	//   const viewHandleClickOpen = () => {
	//     setViewOpen(true)
	//   }

	const updateHandleClickOpen = (row, fs) => {
		console.log("rowwws", row);
		setAddEditBusinessNature(row.role);
		setMccRange(row.mccRange)
		setOperationId(row.operationId);
		// if (fs == "view") {
		// 	setViewOpen(true);
		// }
		if (fs == "edit") {
			setEditOpen(true);
		}
	};

	const view = "view";
	const edit = "edit";

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setOperationId("");
		setAddEditBusinessNature("");
	};

	const addBusinessNature = () => {
		setAddOpen(true);
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
					>
						<Grid item md={3} sm={12} xs={12} lg={3}>
							{/* <NavLink to="/index/add-new-business-nature"> */}
							{/* <Button
							
								size="small"
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								className="riskRuleButton"
								onClick={() => addBusinessNature()}
							>
								Add New Business Nature
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => addBusinessNature()}

							>
								Add New Business Nature
							</CustomButton>
							{/* </NavLink> */}
						</Grid>
						<Grid item md={2} sm={12} xs={12} lg={3}>
							<NavLink to="/index/mapping-business-nature">
								{/* <Button
									size="small"
									style={{
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									className="riskRuleButton"
								>
									Mapping Business Nature
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={() => addBusinessNature()}

								>
									Mapping Business Nature
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Business Nature"
								type="name"
								fullWidth
								variant="standard"
								name="BusinessNature"
								value={businessNature || "Select Business Nature"}
								onChange={handleChange}
							>
								<MenuItem
									value="Select Business Nature"
									selected="Select Business Nature"
								>
									Select Business Nature
								</MenuItem>
								{getBusinessNatureTableListRes.data &&
									getBusinessNatureTableListRes.data.status == "success" &&
									[]
										.concat(getBusinessNatureTableListRes.data.roleList)
										.map((x) => <MenuItem value={x.role}>{x.role}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "17px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={BusinessNatureManagementRequest}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								// endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={BusinessNatureManagementRequest}
							>
								Search<SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{/* <Card > */}
				{/* <CardTitle
            style={{
              marginBottom: "2px",
              textShadow: "none",
              fontSize: "20px",
            }}
           /> */}
				{isLoading ? (
					<LoadingSpinner />
				) : getBusinessNatureResArray.length == undefined ||
					getBusinessNatureResArray.status == "NOT FOUND" ||
					getBusinessNatureResArray.status == "INVALID REQUEST" ||
					!getBusinessNatureListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"
								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									// style={{ padding: "6px 20px 6px 16px !important" }}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Business Nature ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Business Nature
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{getBusinessNatureResArray &&
											[]
												.concat(getBusinessNatureResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														<TableCell align="center">
															{row.operationId}
														</TableCell>
														<TableCell align="center">{row.role}</TableCell>
														<TableCell align="center">
															{/* <Tooltip title="View">
																<CustomButton
																	style={{
																		padding: "8px",
																		margin: "0 8px"
																	}}
																	onClick={() =>
																		updateHandleClickOpen(row, view)
																	}
																>
																	{
																		<VisibilityIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip> */}

															<Tooltip title="Edit">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		updateHandleClickOpen(row, edit)
																	}
																>
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getBusinessNatureResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Business Nature</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								variant="standard"
								label="Business Nature*"
								fullWidth={true}
								name="EditBusinessNature"
								value={addEditBusinessNature || ""}
								onChange={handleChange}
							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="MCC Range*"
								fullWidth={true}
								name="mccnature"
								variant="standard"

								value={mccRange || ""}
								onChange={handleChange}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							{/* <CustomButton
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton> */}
							<CustomButton
								style={{
									// backgroundColor: "#fff",
									// color: "#000",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									// backgroundColor: "#fff",
									// color: "#000",
									color: "white"
								}}
								variant="contained"
								onClick={AddUpdateBusinessNatureRequest}
								disabled={!mccRange || !addEditBusinessNature}
							>
								UPDATE
							</CustomButton>

							{/* <CustomButton
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={AddUpdateBusinessNatureRequest}
							>
								Save
							</CustomButton> */}
							{/* UPDATE
							</Button> */}
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle>Add Business Nature</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Business Nature*"
								fullWidth={true}
								variant="standard"
								name="EditBusinessNature"
								value={addEditBusinessNature || ""}
								onChange={handleChange}
							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="MCC Range*"
								fullWidth={true}
								variant="standard"

								name="mccnature"
								value={mccRange || ""}
								onChange={handleChange}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={AddUpdateBusinessNatureRequest}
								disabled={!mccRange || !addEditBusinessNature}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Business Nature</DialogTitle>
						<DialogContent>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Business Nature*"
								fullWidth={true}
								name="EditBusinessNature"
								value={addEditBusinessNature || ""}
							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="MCC Range*"
								fullWidth={true}
								name="mccnature"
								value={mccRange || ""}
								onChange={handleChange}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "#fff"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				{/* </Card> */}

				{/* {logoutvalue ? <CommonLogout /> : ""} */}
			</Layout >
			{
				updateEntityTypeResArray.status == "success" && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{updateEntityTypeResArray.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button>
							</DialogActions>
						</Dialog>
					</div>
				)
			}

			{
				updateEntityTypeResArray.status == "failed" && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{updateEntityTypeResArray.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button>
							</DialogActions>
						</Dialog>
					</div>
				)
			}

			{
				updateEntityTypeResArray.status == "INVALID REQUEST" && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{updateEntityTypeResArray.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button>
							</DialogActions>
						</Dialog>
					</div>
				)
			}
		</>
	);
};

export default AdminBusinessNatureManagement;
